import Vue from 'vue';
import Comment from '@/components/Comment.vue';

Vue.component('comment-out', Comment);